enum CALL_STATE {
  CONNECTED,
  CONNECTING,
  EXCHANGING_KEYS,
  PENDING,
  REQUESTING,
  CLOSING,
  CLOSED
}

export default CALL_STATE;
